import { Navigate } from 'react-router-dom';

import LoadingOverlay from '../../components/common/LoadingOverlay/LoadingOverlay';
import React from 'react';
import { useCapabilityAccess } from '../../hooks/useCapabilityAccess';

interface DmsAdministratorGuardProps {
  children: React.ReactNode;
}

/**
 * Master Settings are Administrator-only. UI hiding is presentation only - the
 * backend independently enforces DMS_SETTINGS_MANAGE on every settings
 * endpoint regardless of what this guard does.
 */
const DmsAdministratorGuard: React.FC<DmsAdministratorGuardProps> = ({ children }) => {
  const access = useCapabilityAccess();

  if (!access.initialized) {
    return <LoadingOverlay visible />;
  }

  if (!access.canManageDmsSettings) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default DmsAdministratorGuard;
